var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmailLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.895 0 0 0.895 0 2V3.73242L1 4.35938L2 4.98633L10 10L18 5.01953L19 4.39648L20 3.77539V2C20 0.895 19.105 0 18 0H2ZM2 2H18V2.76953L10 7.74805L2 2.73438V2ZM0 6.0918V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V6.13086L18 7.375V14H2V7.3457L0 6.0918Z",
    fill: "#5E7360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailLog);
export default __webpack_public_path__ + "static/media/icon_email_log.9b0200193f28cc096c403b3430b0ccb7.svg";
export { ForwardRef as ReactComponent };